import type { FC } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Nav } from "react-bootstrap";

import EnvelopesOverviewSimple from "components/EnvelopesOverview/EnvelopesOverviewSimple";
import IconArrowForward from "components/Icons/IconArrowForward/IconArrowForward";
import type { IEnvelopeTheme } from "utils/sortTopics";

interface Props {
  theme: IEnvelopeTheme;
  hrefBase: string;
}

const Topic: FC<Props> = ({ theme, hrefBase }) => {
  const { id } = theme;
  const href = id ? `${hrefBase}/${id}` : undefined;

  return (
    <LinkContainer to={href}>
      <Nav.Link className="topic-box gap-1">
        <div className="d-flex gap-1 justify-content-between align-items-center">
          <strong>{theme.themeName}</strong>
          <EnvelopesOverviewSimple envelopes={theme.envelopes} />
        </div>
        <div className="topic-box__assignments-count">
          <IconArrowForward />
        </div>
      </Nav.Link>
    </LinkContainer>
  );
};

export default Topic;
